import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class DeleteODNUserCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IDeleteODNUserParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.DELETE;
  override _commandUrl = 'odn/{carrierId}/delete';
  public override setParameters(parameters: IDeleteODNUserParameters) {
    this._commandUrl = this._commandUrl.replace('{carrierId}', parameters.carrierId.toString());
    this._commandBody = parameters;
  }
}

export interface IDeleteODNUserParameters extends ICommandParameters {
  carrierId: string;
  userId: number;
  odnCode: string;
}
